import { createContext, useContext } from 'react';
import type { DrawerTarget } from './content';

/**
 * Opening the drawer is available to any row without prop-drilling through
 * seven views. The handoff also requires lane rows *inside* a drawer to open
 * drawers; the prototype replaces in place rather than stacking, and so does
 * this — one target at a time, set by whoever calls open().
 */
const Ctx = createContext<(t: DrawerTarget) => void>(() => undefined);

export const DrawerProvider = Ctx.Provider;

export function useDrawer(): (t: DrawerTarget) => void {
  return useContext(Ctx);
}
